import { render } from "./DesignationList.vue?vue&type=template&id=62cdb47f"
import script from "./DesignationList.vue?vue&type=script&lang=js"
export * from "./DesignationList.vue?vue&type=script&lang=js"

import "./DesignationList.vue?vue&type=style&index=0&id=62cdb47f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__